<app-table-generator
    [tableInput]="tableGenInput"
    [widgetRef]="widgetRef"
    [showPagination]="true"
></app-table-generator>
